import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const topicsApi = {
  /**
   * List topics in the moderator's shared catalog.
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').SubscriptionTopic[]>>}
   */
  listCatalog: (config) => mod.get('/topics/', config),

  /**
   * List topics with inline buzzwords for a subscriber.
   * @param {number} userId
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').Topic[]>>}
   */
  list: (userId, config) => mod.get(`/subscribers/${userId}/topics/`, config),

  /**
   * @param {number} userId
   * @param {{ topic: string; color?: string }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  create: (userId, body, config) =>
    mod.post(`/subscribers/${userId}/topics/`, body, config),

  /**
   * @param {number} userId
   * @param {number} topicId
   * @param {{ topic?: string; color?: string }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  update: (userId, topicId, body, config) =>
    mod.put(`/subscribers/${userId}/topics/${topicId}`, body, config),

  /**
   * Preview what will be deleted before committing.
   * @param {number} userId
   * @param {number} topicId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  deleteInfo: (userId, topicId, config) =>
    mod.get(`/subscribers/${userId}/topics/${topicId}/delete-info`, config),

  /**
   * @param {number} userId
   * @param {number} topicId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  remove: (userId, topicId, config) =>
    mod.delete(`/subscribers/${userId}/topics/${topicId}`, config),

  /**
   * Bulk import topics + buzzwords from a CSV file.
   * CSV format: TopicName, buzzword1, buzzword2, ...
   * @param {number} userId
   * @param {File} file
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  importCsv: (userId, file, config = {}) => {
    const form = new FormData();
    form.append('file', file);
    // Unset the instance-level 'Content-Type: application/json' default so the
    // browser can auto-set 'multipart/form-data; boundary=...' for the FormData.
    return mod.post(`/subscribers/${userId}/topics/import-csv`, form, {
      ...config,
      headers: { 'Content-Type': undefined, ...config.headers },
    });
  },
};
